export function sortByString(a: string, b: string, reversed?: boolean): number {
    const sortIndex = a.localeCompare(b)
    return reversed ? sortIndex * -1 : sortIndex
}
